// extracted by mini-css-extract-plugin
export default {"fr-view":"Modal_fr-view__XL6Sn","overlay":"Modal_overlay__pD+CB","modal":"Modal_modal__xuVnZ"};